import angular from 'angular';

(function () {
    angular.module('app.core').controller('AppCtrl', AppCtrl);

    AppCtrl.$inject = ['$translate'];

    function AppCtrl($translate) {
        var appVm = this;

        // Trie pour les listes de pays
        appVm.countryTranslated = countryTranslated;

        //-----------------------------
        // Listes des pays
        //-----------------------------
        function countryTranslated(country) {
            if (country && country.code) {
                return $translate.instant('country.' + angular.lowercase(country.code));
            }
            if (country) {
                return $translate.instant('country.' + angular.lowercase(country));
            }
        }
    }
})();
